import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import axios from '../../../constents/axios'

const DeleteEvent = ({ handleClose, eventId, eventTitle, getEvents }) => {
    const handleDelete = () => {
        // Delete the event from the database make to use axios
        axios
            .post(`/events/deleteEvent`, {
                eventId,
                eventTitle
            })
            .then(() => {
                alert(`Event ${eventTitle} deleted successfully!`);
                handleClose();
                getEvents();
            })
            .catch((error) => {
                console.error("Error deleting event:", error);
                alert("Failed to delete event");
            });
    }
  return (
    <Modal show onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Delete Event</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete this event?
        <br />
        Deleting this will also remove it from the events page on the website.
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleDelete}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default DeleteEvent
